import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IJobOffer } from '../../../../../assets/types/dtoTypes';
import { environment } from '../../../../environments/environment';

@Injectable( {
  providedIn: 'root',
} )
export class JobPageService {
  private http = inject(HttpClient);

  private readonly jobUrl = `${environment.apiUrl}/job-offers`;

  languages: { name: string; code: string }[] = [];


  constructor() {}

  deleteJobOffer( id: string ): Observable<void> {
    const url = `${this.jobUrl}/${id}`;
    return this.http.delete<void>( url );
  }

  editJobOffer( id: string, jobData: Partial<IJobOffer> ): Observable<IJobOffer> {
    const url = `${this.jobUrl}/${id}`;
    return this.http.put<IJobOffer>( url, jobData );
  }

}
